export default __webpack_public_path__ + "assets/lokalia.7b4ea29e.webp";